import appLogger from "../../utils/app-logger";
import UserServiceApi from "../../services/user-service-api";
import AuthServiceApi from "../../services/auth-service-api";
import { createCookie, PerquisiteBountyEnable, readCookie } from "../../utils/helpers";
import { userStore } from "../../utils/signals";
import userServiceApi from "../../services/user-service-api";
import { getTenantGroupId, getTenantId } from "../../utils/general-config";
import ssoHandler from "../../utils/ssohandler";
import EmailService from "../../services/email-service-api";
import dashboardOrchestrationServiceApi from "../../services/dashboard-orchestration-service-api";

const signUpUser = async (data) => {
  const queryParams = new URLSearchParams(window.location.search);
  const emailIdCookie = readCookie("seml");
  const signsimplipwd = readCookie("pwd");
  const signsimpliuid = readCookie("uid");
  let isExistingUser = false;
  if (!!signsimpliuid) {
    if (!!emailIdCookie) {
      if (decodeURIComponent(emailIdCookie) === data.email) {
        let userGuid = signsimpliuid.replace(/(.{8})(.{4})(.{4})(.{4})(.{12})/, "$1-$2-$3-$4-$5");
        let userResponse = await userServiceApi.getUser(userGuid);
        let userProfileResponse = await userServiceApi.getUserProfileByServiceToken(userGuid);
        if (
          !!userResponse.parentUserGuid ||
          userResponse.isPremiumUser === true ||
          userProfileResponse.hasViewedSellPage === true ||
          userResponse.portalCD?.toUpperCase() === "WSRB"
        ) {
          isExistingUser = true;
        }
      }
    }
  }

  if (
    !isExistingUser &&
    queryParams.has("evp") &&
    !!emailIdCookie &&
    !!signsimplipwd &&
    decodeURIComponent(emailIdCookie) === data.email
  ) {
    const changePasswordData = {
      userGuid: signsimpliuid,
      newPassword: data.password,
      currentpassword: signsimplipwd,
    };
    await UserServiceApi.updatePassword(changePasswordData);
    const signinDataParams = {
      username: data.email.trim(),
      password: data.password.trim(),
      tenantGroupId: getTenantGroupId(),
      parentId: queryParams.get("pgid"),
      invitationToken: queryParams.get("gusr"),
    };
    var signinResponse = await signInUser(signinDataParams);
    let isValid = !signinResponse.isAccountLocked;
    return { userGuid: signinResponse.validUserGuid, isValid: isValid };
  } else {
    return UserServiceApi.createUser(data)
      .then((response) => {
        if (response.isValid) {
          appLogger.log("inside signUpUser1 ");
          createCookie("userguid", response.userGuid, 1);
          return response;
        } else {
          return response;
          //dispatch(savePersonalInfoFailure(response.data));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
};

const authUserByUserGuid = (authData, domain) => {
  return AuthServiceApi.AuthenticateUser(authData).then(async (authResponse) => {
    const { jwtToken, refreshToken, expiresAt, ssoToken, legacyToken } = authResponse;
    localStorage.setItem("jwtToken", jwtToken);
    localStorage.setItem("refreshToken", refreshToken);
    localStorage.setItem("expiresAt", expiresAt);
    createCookie("jwtToken", jwtToken, 1, domain);
    createCookie("refreshToken", refreshToken, 1, domain);
    createCookie("expiresAt", expiresAt, 1, domain);
    createCookie("ssoauth", "1", 1, domain);
    createCookie("legacyTicket", legacyToken, 1, domain);
    await ssoHandler();
    return authResponse;
    //save the user address from ip-pro
  });
};

const authUser = async (authData, domain) => {
  return AuthServiceApi.LoginUser(authData).then(async (authResponse) => {
    const { jwtToken, refreshToken, expiresAt, ssoToken, legacyToken } = authResponse;
    localStorage.setItem("jwtToken", jwtToken);
    localStorage.setItem("refreshToken", refreshToken);
    localStorage.setItem("expiresAt", expiresAt);
    createCookie("jwtToken", jwtToken, 1, domain);
    createCookie("refreshToken", refreshToken, 1, domain);
    createCookie("expiresAt", expiresAt, 1, domain);
    createCookie("ssoauth", "1", 1, domain);
    createCookie("legacyTicket", legacyToken, 1, domain);
    await ssoHandler();
    return authResponse;
    //save the user address from ip-pro
  });
};
const signInUser = async (data, domain) => {
  return AuthServiceApi.LoginUser(data)
    .then((response) => {
      if (response) {
        // TO make sure old values does not exists..
        const { jwtToken, refreshToken, expiresAt, ssoToken, legacyToken } = response;
        localStorage.setItem("jwtToken", jwtToken, domain);
        localStorage.setItem("refreshToken", refreshToken, domain);
        localStorage.setItem("expiresAt", expiresAt, domain);
        createCookie("jwtToken", jwtToken, 1, domain);
        createCookie("refreshToken", refreshToken, 1, domain);
        createCookie("expiresAt", expiresAt, 1, domain);
        createCookie("ssoToken", ssoToken, 1, domain);
        createCookie("legacyTicket", legacyToken, 1, domain);
        createCookie("ssoauth", "1", 1, domain);
        appLogger.log("inside signUpUser1 ");
        // call user service to get userguid

        return UserServiceApi.getUserByUserName(encodeURIComponent(data.username), data.tenantGroupId).then(
          async (userResponse) => {
            if (userResponse) {
              const { userGuid, isMigrated, isAccountLocked, perquisiteBountyKey, parentUserGuid } = userResponse;
              let isGuestUser = !!parentUserGuid ? true : false;
              var validUserGuid = userGuid;
              if (userGuid.includes("-") == false) {
                validUserGuid = userGuid.replace(/(.{8})(.{4})(.{4})(.{4})(.{12})/, "$1-$2-$3-$4-$5");
              }
              createCookie("userguid", validUserGuid, 1);
              let isPerquisiteBountyEnable = PerquisiteBountyEnable(perquisiteBountyKey, validUserGuid);
              return {
                validUserGuid: validUserGuid,
                isMigratedUser: isMigrated,
                isAccountLocked: isAccountLocked,
                isPerquisiteBountyEnable: isPerquisiteBountyEnable,
                isGuestUser: isGuestUser,
              };
            }
          }
        );
      }
    })
    .catch((error) => {
      // TODO :: Display error message
      if (error.isAxiosError) {
        let errorMsg = `${error.toString()} `;
        if (error.response?.data?.isAccountLocked) {
          console.log("Your account is locked. Please connect to customer support");
        } else {
        }
        throw error;
      }
    });
};

const securecontactverification = (data) => {
  return UserServiceApi.initiateMfa(data).then((response) => {
    return response;
  });
};
const verifyOtp = async (userguid, otp) => {
  try {
    let emailResponse = await EmailService.VerifyOtp(userguid, otp);
    if (!!emailResponse) {
      if (emailResponse.success === false) {
        return false;
      }
      return true;
    }

    return false;
  } catch (error) {
    console.error("❌ OTP verification failed:", error);
  }
};
const updatePhoneNumber = (data) => {
  return UserServiceApi.updatePhoneNumber(data).then((response) => {
    return response;
  });
};

const saveMfaVerificationData = (data) => {
  return AuthServiceApi.SaveMFAVerificationData(data).then((response) => {
    return response;
  });
};
const initiateVerification = async (data) => {
  try {
    if (data?.ContactType === 2) {
      const OperationRequest = {
        operationName: "SMS_VERIFICATION",
        userGuid: data.UserGuid,
        visitGuid: null,
      };

      const operationLimitResponse =
        await dashboardOrchestrationServiceApi.operationLimit(OperationRequest);

      if (operationLimitResponse === 1) {
        console.log("operation Limit reached");
        return false;
      }
    }

    const response = await UserServiceApi.initiateVerification(data);

    if (!response || response?.success === false) {
      return false;
    }

    return response;
  } catch (error) {
    console.error("❌ OTP verification failed:", error);
    return false;
  }
};
const initiateMfa = async (userGuid) => {
  return fetch(`https://auth-api-qa.worksimpli.io/api/v1/mfa/${userGuid}/initiate`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "Bearer " +
        "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsInRva2VuX3R5cGUiOjIwLCJraWQiOiI0NGUwZmY2MzgwY2E0YzhkOWFlNzBjMjExMjc5NGFiNyJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9zaWQiOiIwMDAwMDAwMC0wMDAwLTAwMDAtMDAwMC0wMDAwMDAwMDAwMDAiLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL2dyb3Vwc2lkIjoiN2ZjOWY0MjUtMTQ2My00YThlLTg1NTYtNmM2YjM0Y2ZjZmY2Iiwic2NvcGUiOiJmdWxsYWNjZXNzIiwidGVuYW50X2dyb3VwX2lkIjoiNTgwYzhiNWEtZGI4My00ODM0LTE0ZWYtMDhkOTUwMWU3MzVkIiwibmJmIjoxNzI4NTUzMDk2LCJleHAiOjIwNDQxMjkwOTYsImlzcyI6IkxlZ2FsU2ltcGxpIiwiYXVkIjoiUERGU2ltcGxpIn0.KameEF9JU4__i_tmeiJQprFIpc0gGoNrXE4ti-ZqCqAhT2UflZL6NCz-herJ3pZfRTGUfsvR8n5-kPZeALbv1F_JY3sjEN4k5m-D2r4L2XjnpS7nNTznc2K5SImmounTp5F3kscXTz-qdQMInE3FjDD6U0Dbl8VPCFQR9e1XzS3_cegwTa3-tqcM7bJAsGkC17EQMec-loQiv55FISd_L8_Wq2dt3QbCnEYsR7WBMs2YWuHf2A3JVrhpr99CxRQZDVWvCDpetw9xqEvLKoViTNVKyfeN823KE26uHmRv52geyUJDnpWDCjoezFxQVWl4ODWNag8Wtw74Rx44nyl4pw",
    },
    body: JSON.stringify(userGuid), // not an object!
  });
};
const verifyMfa = async (userGuid, token) => {
  return fetch(`https://auth-api-qa.worksimpli.io/api/v1/mfa/verify`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      UserGuid: userGuid,
      MfaCode: token,
    }),
  }).then((res) => res.ok);
};

export {
  initiateMfa,
  verifyMfa,
  signUpUser,
  authUser,
  authUserByUserGuid,
  securecontactverification,
  verifyOtp,
  saveMfaVerificationData,
  signInUser,
  initiateVerification,
  updatePhoneNumber,
};
